import React, { useEffect, useState } from 'react'
import Chart from "react-apexcharts";

const LineChartBasic = ({ data, xaxis }) => {
  const [options, setOptions] = useState({
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    title: {
      text: 'Product Trends by Month',
      align: 'left'
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      },
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    }
  })

  useEffect(() => {
    if (xaxis) {
      setOptions(prev => ({
        ...prev,
        xaxis: {
          categories: xaxis
        }
      }))
    }
    // eslint-disable-next-line
  }, [xaxis])

  return (
    <div>
      <Chart
        options={options}
        series={data}
        type="line"
        height="400"
      />
    </div>
  )
}

export default LineChartBasic;
